import script from "./ModalParametrosPrimeraRondaMas.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalParametrosPrimeraRondaMas.vue?vue&type=script&setup=true&lang=ts"

import "./ModalParametrosPrimeraRondaMas.vue?vue&type=style&index=0&id=43bea9f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43bea9f0"]])

export default __exports__